































































import { TbMember } from '@/http';
import { Toast } from 'vant';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class noCodeProduct extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    list=[];

    form={
        sellingPrice:null,
        num:1
    }

    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }
    value=null;
    maxLength=10;

    key="";
    editNumType=null;

    isEdit = false;

    created() {
    }   
    
    mounted() {
       
    }

    init(val){
        this.isEdit = true;
        this.form.sellingPrice = val.sellingPrice;
        this.form.num = val.num;
    }

    closeFun(){
        // closeNocode
        // this.show = false;
        // this.getFocus();
        // this.$emit('closeFun');
        this.$emit('closeFun');
    }

    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	number(number) {
		// this.$emit("number", number);
        if(!this.editNumType){
            this.editNumType=1;
        }
        if(number=='.'&&this.editNumType==2) return;
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        if(!this.editNumType) return;
        if(this.editNumType==1){
            this.form.sellingPrice = this.value;
        }else{
            this.form.num = this.value;
        }
    }

    setNumVal(val,type){
        this.maxLength = type==1?10:4;
        this.value = val;
        this.editNumType = type;
    }
    confirmFun(){
        if(!this.form.sellingPrice){
            Toast("请输入售价");
            return;
        }
        if(!this.form.num){
            Toast("请添加商品数量");
            return;
        }
        if(Number(this.form.sellingPrice)==0){
            Toast("售价不能为0");
            return;
        }
        if(Number(this.form.num)==0){
            Toast("数量不能为0");
            return;
        }
        this.form.num = Number(this.form.num);
        if(!this.isEdit){
            this.$emit("addNoCode",this.form);
        }else{
            this.$emit("editNoCode",this.form);
        }
        this.closeFun();
    }
    minusFun(){
        this.editNumType = 2;
        if(!this.form.num||Number(this.form.num)==0) return;
        this.form.num--;
    }
    addFun(){
        this.editNumType = 2;
        if(Number(this.form.num)==9999) return;
        if(!this.form.num){
            this.form.num=1
        }else{
            this.form.num++;
        }
    }
    getFocus(){
        window.webkit.messageHandlers.getFocus.postMessage('getFocus');
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/noCodeProduct.vue